// extracted by mini-css-extract-plugin
export default {"playIcon":"AudioPlayer_playIcon__qJx0Z","pauseIcon":"AudioPlayer_pauseIcon__QCfGJ"};